import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from '@redux';
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

interface IModalConfirmActionProps {
  handleCancel: () => void;
  handleConfirm: () => DynamicObjectType;
  title: string;
  description?: string;
  keyModal: string;
  callback?: () => void;
}

const ModalConfirmAction = ({
  handleCancel,
  handleConfirm,
  title,
  description,
  keyModal,
  callback,
}: IModalConfirmActionProps) => {
  const { t } = useTranslation();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);

  const [loading, setLoading] = useState(false);

  const onCancel = () => {
    handleCancel();
  };

  const onOk = async () => {
    setLoading(true);
    try {
      const res = await handleConfirm();
      await setLoading(false);
      await onCancel();
      if (res?.payload?.success) {
        callback && callback();
      }
    } catch {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={modal?.[keyModal]?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
    >
      <div className="grid gap-5">
        <div className="text-center">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-[--primary] mb-[5px] text-[24px]"
          />
          <div className="text-[16px] font-semibold">{t(title)}</div>
        </div>
        <div className="text-center text-[#53575D] text-sm">
          {t(description)}
        </div>
        <div className="flex justify-center items-center gap-2.5">
          <Button className="btn-light h-[40px] w-[100px]" onClick={onCancel}>
            {t('button.cancel')}
          </Button>
          <Button
            className="h-[40px] w-[100px]"
            type="primary"
            onClick={onOk}
            loading={loading}
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirmAction;
